import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RdNavbarDirective } from './rd-navbar.directive';



@NgModule({
  declarations: [RdNavbarDirective],
  imports: [
    CommonModule
  ],
  exports: [RdNavbarDirective]
})
export class SharedModule { }
